// All screen views for the AccountLoginRegistration component
export const SCREENS = {
  REGISTER: 'register',
  LOGIN: 'login',
  SOCIAL_REGISTRATION: 'socialRegistration',
  LOGIN_OTC_EMAIL: 'loginOTCEmail',
  VERIFY_OTC: 'verifyOneTimeCode',
  LOGIN_OTC: 'loginWithOneTimeCode',
  USER_NAME: 'userName',
  REGISTRATION_SUCCESS: 'registrationSuccess',
  LOGIN_SUCCESS: 'loginSuccess',
  NBCU_PROFILE: 'nbcuProfile',
  SELECT_INTERESTS: 'selectInterests',
};

// Screens that display the background “circles” element
export const SCREENS_WITH_CIRCLES = [
  SCREENS.REGISTER,
  SCREENS.LOGIN,
];

// entry point screens
export const LOGIN_ENTRY_SCREENS = [
  SCREENS.LOGIN,
  SCREENS.REGISTER,
];

// screens that must NEVER show a back button
export const NO_BACK_SCREENS = [
  SCREENS.REGISTER,
  SCREENS.LOGIN,
  SCREENS.USER_NAME,
];

// success screens
export const SUCCESS_SCREENS = [
  SCREENS.LOGIN_SUCCESS,
  SCREENS.REGISTRATION_SUCCESS,
];

// treat these as post-auth
export const POST_LOGIN_SCREENS = [
  ...SUCCESS_SCREENS,
  SCREENS.USER_NAME,
];
